// removed by extract-text-webpack-plugin
module.exports = {"searchLnk":"NavigationMenu__searchLnk___2Do3d"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/Start/NavigationMenu/NavigationMenu.scss
// module id = 748
// module chunks = 0